import { Link } from '@tanstack/react-router';
import { Compass } from 'lucide-react';
import { EmptyState } from '../ui/States.jsx';
import { Button } from '../ui/Button.jsx';

export function NotFound() {
  return (
    <EmptyState
      icon={Compass}
      title="This page doesn’t exist"
      body="The link may be old, or the record may have been removed."
      action={<Button as={Link} to="/dashboard" variant="secondary">Go to the dashboard</Button>}
    />
  );
}
